import { PinInput, type PinInputProps } from '@chakra-ui/react' 
import { SizeType, InputVariant } from '@/types'


interface Props extends PinInputProps {
  variant?: InputVariant,
  size?: SizeType,
}

function Component(props: Props) {
  return (
    <PinInput {...props} />
  )
}

export {
  Component as PinInput,
  type Props as PinInputProps,
}